'use strict';

var _ = require('lodash');
var ListboxDirective = function ListboxDirective($timeout) {
  var displayMember = 'name';
  var valueMember = 'dbPath';
  function getListboxSettings(items, multipleSelection) {
    return {
      width: 400,
      height: 300,
      multiple: multipleSelection,
      displayMember: displayMember,
      valueMember: valueMember,
      source: items
    };
  }
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/listbox.html'),
    require: 'ngModel',
    scope: {
      items: '=',
      header: '@',
      emitDblClick: '=',
      multipleSelection: '='
    },
    link: function link($scope, elem) {
      $scope.listItems = [];
      $scope.listBoxSettings = getListboxSettings($scope.listItems, $scope.multipleSelection);
      $scope.$watch('items', function () {
        $scope.listItems.length = 0;
        $scope.listItems.push.apply($scope.listItems, $scope.items);
      });
      if ($scope.emitDblClick) {
        $timeout(function () {
          var listbox = elem.find('.jqx-listbox').eq(0);
          listbox.on('dblclick', '.jqx-listitem-state-normal', function () {
            var obj = _.find($scope.listItems, [valueMember, $scope.selectedValue]);
            $scope.$emit('listbox-item:dblclicked', obj);
          });
        }, 0);
      }
    }
  };
};
ListboxDirective.$inject = ['$timeout'];
module.exports = ListboxDirective;